let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined,
  name: undefined,
  name_lang: {
    vi: undefined,
    en: undefined,
  },
  table_ids: [],
};

// Cấu hình bảng danh sách
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "-name",
  defaultSort: ["-name", "descending"],
  fields: "id,name,name_lang,table_ids",
  filters: "",
  dataSearch: {
    value: {
      name: "",
      "name_lang.vi": "",
      "name_lang.en": "",
    },
    operator: {
      name: ":regex_i:",
      "name_lang.vi": ":regex_i:",
      "name_lang.en": ":regex_i:",
    },
  },
};

export default model;
